import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.z1z_1 = serializer;
        this.a20_1 = new (SerialDescriptorForNullable())(this.z1z_1.s1m());
      }
      s1m() {
        return this.a20_1;
      }
      b20(encoder, value) {
        if (!(value == null)) {
          encoder.f1t();
          encoder.c1t(this.z1z_1, value);
        } else {
          encoder.f1s();
        }
      }
      t1m(encoder, value) {
        return this.b20(encoder, value);
      }
      u1m(decoder) {
        return decoder.u1q() ? decoder.i1r(this.z1z_1) : decoder.v1q();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.z1z_1, other.z1z_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.z1z_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.i1p_1 = original;
        this.j1p_1 = this.i1p_1.v1n() + '?';
        this.k1p_1 = cachedSerialNames(this.i1p_1);
      }
      v1n() {
        return this.j1p_1;
      }
      s1q() {
        return this.k1p_1;
      }
      h1p() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.i1p_1, other.i1p_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.i1p_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.i1p_1), 31);
      }
      o1p() {
        return this.i1p_1.o1p();
      }
      p1p() {
        return this.i1p_1.p1p();
      }
      q1p() {
        return this.i1p_1.q1p();
      }
      r1p() {
        return this.i1p_1.r1p();
      }
      s1p(index) {
        return this.i1p_1.s1p(index);
      }
      t1p(name) {
        return this.i1p_1.t1p(name);
      }
      u1p(index) {
        return this.i1p_1.u1p(index);
      }
      v1p(index) {
        return this.i1p_1.v1p(index);
      }
      w1p(index) {
        return this.i1p_1.w1p(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
